module.exports = __webpack_public_path__ + "img/project-start1.f0146a34.png";